import {
  StyleCard,
  StyleLeftBannerWrapper,
  StyleRightBannerWrapper,
} from './style'
import Image from '@components/image'
import Typography from '@components/typography'
import Button from '@components/button'
import BannerImg from './banner.png'
import Svg from '@components/svg'
import { useNavigate, useSearchParams } from 'react-router-dom'
const Banner = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const tab = searchParams.get('tab')
  const handleClick = async () => {
    if (!tab || tab == 'doctors') {
      navigate('/institution/staffs/doctor')
    } else {
      navigate('/institution/staffs/health-provider')
    }
  }
  return (
    <StyleCard>
      <StyleLeftBannerWrapper>
        <Typography
          content={`Create Staff Profiles`}
          tc="primary"
          weight={500}
          size={18}
        />
        <Typography
          content={`Build complete records for every team member. Ensure seamless coordination across departments with up-to-date staff information.`}
          tc="text"
          weight={500}
          size={18}
        />
        <Button
          leftComponent={<Svg svg="circlePlus" color={'white'} />}
          title={!tab || tab == 'doctors' ? 'Add Doctor' : 'Add Medical Staff'}
          height={45}
          styleButtonWrapper="margin-top:10px;"
          onClick={handleClick}
        />
      </StyleLeftBannerWrapper>
      <StyleRightBannerWrapper>
        <Image src={BannerImg} height={200} />
      </StyleRightBannerWrapper>
    </StyleCard>
  )
}

export default Banner
